"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.collectionSort).on("change", function (event) {
    var sortQuery = this.value;
    handlers.sortBy(sortQuery);
  });
  $(Dom.clearFilters).on("click", function (event) {
    handlers.clearFilters();
  });
};
